import React, { useState } from 'react';
import './ClientSearchBar.css';

const ClientSearchBar = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState('');
  
  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };
  
  return (
    <div className="client-search-bar">
      <input
        type="text"
        placeholder="Buscar cliente..."
        value={searchTerm}
        onChange={handleChange}
        className="search-input"
      />
    </div>
  );
};

export default ClientSearchBar;